import { Document, Page, View, StyleSheet } from "@react-pdf/renderer";
import React from "react";
import {
  Table,
  TableHeader,
  TableCell,
  TableBody,
  DataTableCell,
} from "@david.kucsai/react-pdf-table";

// import { numberWithCommas } from "../../../helpers/dataHelpers";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    fontSize: 10,
  },
  section: {
    margin: 1,
    padding: 10,
    flexGrow: 1,
    fontSize: 10,
  },
});

export const DailyReportsPdfToRenderOverallComponent = (data) => (
  <Document>
    <Page wrap={true} orientation="landscape" size="A4" style={styles.page}>
      <View wrap={true}>
        <Table data={data}>
          <TableHeader>
            <TableCell>Cluster Name</TableCell>
            {/* <TableCell># of Branches</TableCell> */}
            <TableCell>#Pwn</TableCell>
            <TableCell>#Rdm</TableCell>
            <TableCell>P/R Diff</TableCell>
            <TableCell>Amt Pawn</TableCell>
            <TableCell>Amt Redm</TableCell>
            <TableCell>Amt Diff</TableCell>
            <TableCell>Gross</TableCell>
            <TableCell>Total Pcs</TableCell>
            <TableCell>Total Amt</TableCell>
            <TableCell>Ave/Amt/Pc</TableCell>
          </TableHeader>
          <TableBody>
            <DataTableCell
              textAlign={"center"}
              getContent={(r) => r.clusterName}
            />
            {/* <DataTableCell getContent={(r) => r.branchCount} /> */}
            <DataTableCell getContent={(r) => r.totalPiecesDetail.newPawn} />
            <DataTableCell
              getContent={(r) =>
                r.totalPiecesDetail.newPawn - r.totalPiecesDetail.redeemedPawn
              }
            />
            <DataTableCell getContent={(r) => r.totalPrincipalDetail.newPawn} />
            <DataTableCell
              getContent={(r) => r.totalPrincipalDetail.redeemedPawn}
            />
            <DataTableCell
              getContent={(r) =>
                r.totalPrincipalDetail.newPawn -
                r.totalPrincipalDetail.redeemedPawn
              }
            />
            <DataTableCell
              getContent={(r) =>
                r.grossProfitDetail.totalNewPawnCharges +
                r.grossProfitDetail.totalRedeemedPawnCharges
              }
            />
            <DataTableCell
              getContent={(r) => r.grossProfitDetail.totalNewPawnCharges}
            />
            <DataTableCell getContent={(r) => r.totalPieces} />
            <DataTableCell getContent={(r) => r.totalPrincipal} />
            <DataTableCell getContent={(r) => r.averagePrincipalPerPiece} />
          </TableBody>
        </Table>
      </View>
    </Page>
  </Document>
);

export const DailyReportsPdfToRenderAreaComponent = (data) => (
  <Document>
    <Page wrap={true} orientation="landscape" size="A4" style={styles.page}>
      <View wrap={true}>
        <Table data={data}>
          <TableHeader>
            <TableCell>Area Name</TableCell>
            {/* <TableCell># of Branches</TableCell> */}
            <TableCell>#Pwn</TableCell>
            <TableCell>#Rdm</TableCell>
            <TableCell>P/R Diff</TableCell>
            <TableCell>Amt Pawn</TableCell>
            <TableCell>Amt Redm</TableCell>
            <TableCell>Amt Diff</TableCell>
            <TableCell>Gross</TableCell>
            <TableCell>Total Pcs</TableCell>
            <TableCell>Total Amt</TableCell>
            <TableCell>Ave/Amt/Pc</TableCell>
          </TableHeader>
          <TableBody>
            <DataTableCell
              textAlign={"center"}
              getContent={(r) => r.areaName}
            />
            {/* <DataTableCell getContent={(r) => r.branchCount} /> */}
            <DataTableCell getContent={(r) => r.totalPiecesDetail.newPawn} />
            <DataTableCell
              getContent={(r) =>
                r.totalPiecesDetail.newPawn - r.totalPiecesDetail.redeemedPawn
              }
            />
            <DataTableCell getContent={(r) => r.totalPrincipalDetail.newPawn} />
            <DataTableCell
              getContent={(r) => r.totalPrincipalDetail.redeemedPawn}
            />
            <DataTableCell
              getContent={(r) =>
                r.totalPrincipalDetail.newPawn -
                r.totalPrincipalDetail.redeemedPawn
              }
            />
            <DataTableCell
              getContent={(r) =>
                r.grossProfitDetail.totalNewPawnCharges +
                r.grossProfitDetail.totalRedeemedPawnCharges
              }
            />
            <DataTableCell
              getContent={(r) => r.grossProfitDetail.totalNewPawnCharges}
            />
            <DataTableCell getContent={(r) => r.totalPieces} />
            <DataTableCell getContent={(r) => r.totalPrincipal} />
            <DataTableCell getContent={(r) => r.averagePrincipalPerPiece} />
          </TableBody>
        </Table>
      </View>
    </Page>
  </Document>
);

export const DailyReportsPdfToRenderBranchComponent = (data) => (
  <Document>
    <Page wrap={true} orientation="landscape" size="A4" style={styles.page}>
      <View wrap={true}>
        <Table data={data}>
          <TableHeader>
            <TableCell>Branch Name</TableCell>
            {/* <TableCell># of Branches</TableCell> */}
            <TableCell>#Pwn</TableCell>
            <TableCell>#Rdm</TableCell>
            <TableCell>P/R Diff</TableCell>
            <TableCell>Amt Pawn</TableCell>
            <TableCell>Amt Redm</TableCell>
            <TableCell>Amt Diff</TableCell>
            <TableCell>Gross</TableCell>
            <TableCell>Total Pcs</TableCell>
            <TableCell>Total Amt</TableCell>
            <TableCell>Ave/Amt/Pc</TableCell>
          </TableHeader>
          <TableBody>
            <DataTableCell
              textAlign={"center"}
              getContent={(r) => r.branchName}
            />
            {/* <DataTableCell getContent={(r) => r.branchCount} /> */}
            <DataTableCell getContent={(r) => r.totalPiecesDetail.newPawn} />
            <DataTableCell
              getContent={(r) =>
                r.totalPiecesDetail.newPawn - r.totalPiecesDetail.redeemedPawn
              }
            />
            <DataTableCell getContent={(r) => r.totalPrincipalDetail.newPawn} />
            <DataTableCell
              getContent={(r) => r.totalPrincipalDetail.redeemedPawn}
            />
            <DataTableCell
              getContent={(r) =>
                r.totalPrincipalDetail.newPawn -
                r.totalPrincipalDetail.redeemedPawn
              }
            />
            <DataTableCell
              getContent={(r) =>
                r.grossProfitDetail.totalNewPawnCharges +
                r.grossProfitDetail.totalRedeemedPawnCharges
              }
            />
            <DataTableCell
              getContent={(r) => r.grossProfitDetail.totalNewPawnCharges}
            />
            <DataTableCell getContent={(r) => r.totalPieces} />
            <DataTableCell getContent={(r) => r.totalPrincipal} />
            <DataTableCell getContent={(r) => r.averagePrincipalPerPiece} />
          </TableBody>
        </Table>
      </View>
    </Page>
  </Document>
);
